import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import { InnerPageContainer } from '../../InnerPageContainer/InnerPageContainer';
import { AltenarWidgetBonuses } from './components';

type SportsbookFreeBetsProps = ComponentProps<typeof InnerPageContainer>;

function SportsbookFreeBets({ className, ...props }: SportsbookFreeBetsProps) {
  return (
    <InnerPageContainer className={twMerge(className, 'll-container-full bg-background')} {...props}>
      <div className="ll-container-inner py-6 px-(--ll-container-padding) min-h-150 sm-md:px-10 sm-md:bg-container">
        <AltenarWidgetBonuses />
      </div>
    </InnerPageContainer>
  );
}

export { SportsbookFreeBets };
